import getHistory from '@/components/global-history'
export const injectJs2native = (window: Window) => {
  const js2native = {
    page2GoodDetail(id: string) {
      getHistory().push(`/goods-detail/${id}`)
    },
    page2Search() {
      getHistory().push(`/search`)
    }
  }

  if (window) {
    window.js2native = js2native
    return true
  }
  return false
}
